<template>
  <div class="mallShopGoodsMore">
    <!--<van-pull-refresh v-model="refreshLoading" @refresh="onRefresh"></van-pull-refresh>-->
      <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="isError"
          error-text="请求失败，点击重新加载"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <shop-goods-item v-for="(item, i) in dataList" :key="i" :item="item" />
      </van-list>

  </div>
</template>

<script>
import { sgShopGoodsList } from '@/api/mall/mallGoods'
import shopGoodsItem from '@/views/Mall/sg/components/shopGoodsItem'
export default {
  components: {
    shopGoodsItem,
  },
  data(){
    return {
      dataList: [], // 列表数据
      refreshLoading: false,

      loading: false,
      finished: false,
      isError: false,

      page: 1,
      size: 10,
    }
  },
  methods: {
    onRefresh(){
      this.page = 1;
      window.setTimeout(()=>{
        this.finished = false;
        this.dataList = [];
        this.refreshLoading = false;
        window.scrollTo(0, 0);
      },100)
    },
    onLoad() {
      let req = {
        shopId: this.$route.query.shopId,
        page: this.page,
        size: this.size
      }
      if(this.$route.query.inviteUserId){
        req.inviteUserId = this.$route.query.inviteUserId
      }
      sgShopGoodsList(req).then(res => {
        let dataList = [];
        dataList = res.data.items || [];
        if(dataList.length>0){ //是否有数据
          // 如果是第一页需手动制空列表
          if (this.page === 1){
            this.dataList = [];
          }
          // 把请求到的数据添加到列表
          this.dataList = this.dataList.concat(dataList)
          this.page++
          this.loading = false
        }else {
          this.loading = false;
          this.finished = true;
        }
      }).catch(() => {
        this.error = true;
      })
    },



    // 跳转至商品详情
    goDetail(item) {
      let query = {goodsId: item.goodsId, shopId: this.$route.query.shopId, courseType: item.courseType||null };
      if(this.$route.query.inviteUserId){
        query.inviteUserId = this.$route.query.inviteUserId
      }
      this.$router.push({name: 'goodsDetail', query })
    },
  }
}
</script>

<style lang="less" scoped>
.mallShopGoodsMore{

}
</style>